import React from 'react';
import { Link } from 'react-router-dom';
import { preventOrphanWords } from '../../../utils/formatters';
import { useAlbum } from '../../../contexts/AlbumContext';

const getServiceUrl = (album, service) => {
  switch (service) {
    case 'spotify': return `spotify:album:${album.spotifyId}`;
    case 'youtubeMusic': return `https://music.youtube.com/playlist?list=${album.youtubeMusicId}`;
    case 'appleMusic': return `https://music.apple.com/album/${album.appleMusicId}`;
    case 'amazonMusic': return `https://music.amazon.com/albums/${album.amazonMusicId}`;
    case 'tidal': return `https://tidal.com/browse/album/${album.tidalId}`;
    case 'deezer': return `https://www.deezer.com/album/${album.deezerId}`;
    case 'qobuz': return `https://play.qobuz.com/album/${album.qobuzId}`;
    default: return null;
  }
};

const AlbumTitle = ({ title, subtitle, className = "" }) => {
  const { currentAlbum } = useAlbum();
  const preferredService = localStorage.getItem('preferredMusicService') || 'spotify';

  const wordCount = title.split(' ').length;
  const hasLongWord = title.split(' ').some(word => word.length >= 7);

  const textSizeClasses = hasLongWord
    ? "xl:text-[6rem] lg:text-[5.125rem] md:text-[4.25rem] sm:text-[3.375rem] text-[2.5rem] xl:leading-[6.3rem] lg:leading-[5.38rem] md:leading-[4.46rem] sm:leading-[3.54rem] leading-[2.625rem]"
    : wordCount <= 2
      ? "xl:text-[10rem] lg:text-[8.5rem] md:text-[7rem] sm:text-[5.5rem] text-[4rem] xl:leading-[10.5rem] lg:leading-[8.925rem] md:leading-[7.35rem] sm:leading-[5.775rem] leading-[4.2rem]"
      : wordCount <= 4
        ? "xl:text-[8rem] lg:text-[6.625rem] md:text-[5.25rem] sm:text-[3.875rem] text-[2.5rem] xl:leading-[8.4rem] lg:leading-[7rem] md:leading-[5.5rem] sm:leading-[4rem] leading-[2.625rem]"
        : "xl:text-[6rem] lg:text-[5.125rem] md:text-[4.25rem] sm:text-[3.375rem] text-[2.5rem] xl:leading-[6.3rem] lg:leading-[5.38rem] md:leading-[4.46rem] sm:leading-[3.54rem] leading-[2.625rem]";

  const titleContent = hasLongWord ? title : preventOrphanWords(title);
  const serviceUrl = currentAlbum ? getServiceUrl(currentAlbum, preferredService) : null;

  return (
    <div className="flex flex-col items-center pt-5 pb-6 sm:px-8 px-4 md:gap-8 gap-4 text-amber-50 lg:min-h-[50vh] h-fit">

      {subtitle && (
        <div className="flex w-full justify-center text-center pangram-sans-bold sm:text-3xl text-2xl">
          <div>{preventOrphanWords(subtitle)}</div>
        </div>
      )}

      <div className={`flex flex-1 items-center pangram-sans-narrow-extrabold ${textSizeClasses} text-center ${className}`}>
        {titleContent}
      </div>

      <div className="flex flex-row w-full gap-4 justify-between items-end">

        <a
          className="hover:scale-110 transition duration-100 ease-in-out"
          href={`https://1001albumsgenerator.com/${localStorage.getItem('albumGeneratorUser')}`}
          target="_blank"
          rel="noopener noreferrer"
          data-adblock-ignore
        >
          <div className="group flex flex-col sm:h-6 h-4 sm:w-6 w-4 justify-center items-center cursor-pointer text-center pangram-sans-bold">
            <span className="material-symbols-outlined text-2xl">language</span>
          </div>
        </a>

        {serviceUrl && (
          <a
            className="hover:scale-110 transition duration-100 ease-in-out"
            href={serviceUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="group flex flex-col justify-center items-center cursor-pointer text-center pangram-sans-bold leading-4">
              <span className="material-symbols-outlined sm:text-6xl text-5xl">play_circle</span>
            </div>
          </a>
        )}

        <Link
          to="/settings"
          className="hover:scale-110 transition duration-100 ease-in-out"
        >
          <div className="group flex flex-col sm:h-6 h-4 sm:w-6 w-4 justify-center items-center cursor-pointer text-center pangram-sans-bold">
            <span className="material-symbols-outlined text-2xl">tune</span>
          </div>
        </Link>

      </div>

    </div>
  );
};

export default AlbumTitle;